<script>
  import { locale } from 'svelte-i18n';

  export let keyword;
  export let iconClass;
  export let onClick;
  export let selected;
</script>

<button
  class="icon-button keyword-list__item {selected ? 'keyword-list__item--active' : ''}"
  aria-label="{keyword.name[$locale] ? keyword.name[$locale] : keyword.name.fi}"
  aria-pressed="{selected}"
  on:click={() => onClick(keyword.id)}>
  {#if iconClass}
    <i class="keyword-list__item__icon {iconClass}"></i>
  {/if}
  <span lang="{keyword.name[$locale] ? $locale : 'fi'}">{keyword.name[$locale] ? keyword.name[$locale] : keyword.name.fi}</span>
</button>

<style>
</style>
